import { Component, Input } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EvaluationState } from '@proxy/evaluations';

@Component({
    selector: 'app-evaluation-state-tag',
    templateUrl: './evaluation-state-tag.component.html',
    standalone: false
})
export class EvaluationStateTagComponent extends AppBaseComponent {
  @Input({ required: true }) evaluationState: EvaluationState;

  protected readonly EvaluationState = EvaluationState;
}
